<div [formGroup]="form" *ngIf="form != null">
  <div class="row">
    <div class="col-3">
      <label for="employeeStatus">Employee Status</label>
      <select class="form-control" id="employeeStatus" formControlName="employeeStatus">
        <option [value]="null">Select All</option>
        <option *ngFor="let status of statuses" [value]="status.Id">{{ status.Value }}</option>
      </select>
    </div>
  </div>
  <div class="row">
    <div class="col-4">
      <p>Do you want to select a timeframe to run this report?</p>
    </div>
    <div class="col-1">
      <input
        type="radio"
        id="radio-yes"
        name="setTimeframe"
        formControlName="setTimeframe"
        [value]="true" />
      <label for="radio-yes" title="Yes"><span></span>Yes</label>
    </div>
    <div class="col-1">
      <input
        type="radio"
        id="radio-no"
        name="setTimeframe"
        formControlName="setTimeframe"
        [value]="false" />
      <label for="radio-no" title="No"><span></span>No</label>
    </div>
  </div>
  <div class="row" *ngIf="setTimeframe">
    <div class="col-12 col-md-4">
      <label>Timeframe</label>
      <lib-date-range-picker formControlName="dateRange"></lib-date-range-picker>
    </div>
  </div>
  <div class="row" *ngIf="form.errors?.['invalidDateRange'] && form.touched">
    <div class="col-12">
      <p class="error-text">Begin date should be before End date</p>
    </div>
  </div>
  <div class="row">
    <div class="col-12 col-md-4">
      <lib-checkbox
        [label]="'Exclude Employees Terminated Prior to'"
        formControlName="enableExcludeDate"></lib-checkbox>
    </div>
    <div class="col-12 col-md-3">
      <div class="input-group">
        <input
          id="excludeEmployeesTerminatedPriorTo"
          type="text"
          class="form-control datepicker"
          formControlName="excludeEmployeesTerminatedPriorTo"
          ngbDatepicker
          #excludeEmployeesTerminatedPriorTo="ngbDatepicker"
          [firstDayOfWeek]="7"
          [placement]="['bottom-end', 'top-end']" />
        <img
          src="assets/icons/calendar.svg"
          (click)="excludeEmployeesTerminatedPriorTo.toggle()"
          class="icon-append" />
      </div>
    </div>
  </div>
  <lib-report-buttons
    *ngIf="form != null"
    [disabled]="form.invalid"
    (generateReport)="generateReport()"
    (downloadReport)="downloadReport($event)"></lib-report-buttons>
</div>
